import React from 'react'

function Heading(props) {
  return (
        <h2 className={`${props.className} text-2xl md:text-3xl text-gray-700 lg:text-4xl text-head font-bold`}>{props.heading}</h2>
  )
}

export default Heading